import { IStatusMessage } from '../../shared';

export interface UserSetting {
    CatID: number;
    CatDescription: string;
    EmployeeListID: string;
    EmpSettingID: number;
    EmpSettingType: string;
    EmpSettingTypeLabel: string;
    EmpSettingValue: any;
    CtrlType: string;
    Validation: string;
    Isconfirmrequired: boolean;
    Status: IStatusMessage;
    Row_Version: string;
    UserDefined: boolean;
}

export enum UserSettingType {
    TimeCardAutoRefresh = 1,
    TCWebViewComments = 2,
    TCWebViewHrsRemaining = 3,
    TCWebDisplayTotal = 4,
    TCWebTaskDisplayOrder = 5,
    TCWebMyTaskDisplay = 6,
    TCWSplitOptionID = 7,
    TCWInitialPage = 8,
    TCWSendMail = 9,
    TCWebInitialView = 10,
    TCWebSupvInitialView = 11,
    TCWUseHTMLOnly = 12,
    TimeGridHeight = 13,
    FirstDayOfWeek = 14,
    showWeeklySummary = 15,
    displayauthperiod = 16,
    ExpenseGridHeight = 17,
    WorkSummaryGridHeight = 18,
    TimeZone = 20,
    initialtimecardview = 21,
    initialtimecardviewrole = 22,
    initialtimecardscopeasuser = 23,
    initialtimecardscopeassupervisor = 24,
    initialtimecardscopeasuserclassic = 25,
    initialtimecardscopeassupervisorclassic = 26,
    TwoFactorSecurityQuestion = 27,
    TwoFactorSecurityAnswer = 28,
    eFCTheme = 29,
    efcdarkmode = 30,
    ShowUserMsg = 31,
    AccessCode = 32,
    RemainingAttempts = 33,
    LastAttemptTime = 34,
    LastAttemptType = 35,
    TemporaryPassword = 36,
    PasswordWarning = 37,
    UserAIHelpButton = 38
}

/** EmpSettingType string keys used with getSettingBooleanValue / store selectId. */
export enum UserSettingEmpSettingType {
    TemporaryPassword = 'TemporaryPassword',
    PasswordWarning = 'PasswordWarning',
    UserAIHelpButton = 'UserAIHelpButton'
}
